<template lang="html">

  <div class="wrapper-view -momento-ganador">

    <template v-if="showFormulario">

      <div class="contenedor-menu">
        <nav class="menu row-center">
          <a @click="scrollTo('como-participar')">Cómo Participar</a>
          <a @click="scrollTo('premios')">Premios</a>
          <a @click="scrollTo('productos')" class="hide-mvl">Productos TOP</a>
          <a @click="scrollTo('productos')" class="hide-pc">Productos</a>
        </nav>
      </div>

      <div class="contenedor-intro-formulario">


        <div class="contenedor-imagen-premio column-center">
          <div class="contenedor-logo">
            <img src="/static/img/momento-ganador/metele-fiesta-big.png" alt="Mete fiesta" class="logo">
          </div>
          <img src="/static/img/momento-ganador/intro-avion.gif" alt="Gana un coche y muchos premios más!" class="premios">


          <img src="/static/img/momento-ganador/imagen-home-pc.png" alt="Gana un coche" class="pc">


          <a class="down" @click="down"><img src="/static/img/momento-ganador/flecha.svg" alt="Flecha" class="down"></a>


        </div>
        <!-- <div class="close">
          <h3>El sorteo del coche se realizará el día 15 de septiembre ante Notario y el ganador/a será anunciado en
            esta página y nuestras redes sociales a finales del mismo mes.</h3>
          <h3>Permanece atento/a y no te pierdas las próximas novedades. Gracias por participar</h3>
        </div> -->

        <formulario @finish="initRuleta"></formulario>

      </div>

      <div class="contenedor-video">

        <video controls playsinline="true" poster="/static/img/momento-ganador/frame-video-uno.jpg">
          <source src="/static/img/momento-ganador/video-uno.mp4" type="video/mp4">
        </video>

      </div>

      <section class="como-participar" id="como-participar">

        <h2 class="title">
          ¿Cómo participar?
        </h2>

        <div class="container row-center ais">

          <img src="/static/img/momento-ganador/estrellas.svg" alt="estrellas" class="estrellas-1">
          <img src="/static/img/momento-ganador/estrellas-dos.svg" alt="estrellas" class="estrellas-2">

          <article class="tip-participacion">
            <div class="imagen"><img width="140" src="/static/img/momento-ganador/icon-abrelo.png" alt="Ábrelo"></div>
            <h3>BUSCA los CÓDIGOs EN los ENVOLTORIOs
              de kojak original y kojak pop</h3>
          </article>
          <article class="tip-participacion">
            <div class="imagen"><img src="/static/img/momento-ganador/icon-chupalo.png" alt="Chúpalo"></div>
            <h3>Canjéalo en el formulario de participación</h3>
          </article>
          <article class="tip-participacion">
            <div class="imagen"><img src="/static/img/momento-ganador/icon-gozalo.png" alt="Gózalo"></div>
            <h3>Consigue fantásticos premios</h3>
          </article>

        </div>

        <!-- <img src="/static/img/momento-ganador/piruleta.png" alt="piruleta" class="piruleta"> -->

      </section>

      <slider-premios></slider-premios>


      <div class="contenedor-40">
        <p>Consigue tus pases VIP y disfruta un verano top</p>
        <img src="/static/img/momento-ganador/logo-40.png" alt="Los 40">
      </div>


      <div class="contenedor-video">



        <video controls playsinline="true" poster="/static/img/momento-ganador/frame-video-dos.jpg">
          <source src="/static/img/momento-ganador/video-dos.mp4" type="video/mp4">
        </video>

      </div>


      <section class="productos" id="productos">

        <h2 class="title">Productos Top</h2>

        <h3 class="subtitle -white">¡Busca los códigos en los envoltorios!</h3>

        <div class="container row-center">

          <!-- <article class="producto">
            <div class="imagen"><img src="/static/img/momento-ganador/bolsa-cereza-7.png" alt="Piruleta Original - Bolsa 100 ud"></div>
            <h3>Kojak Cereza<br>Bolsa 7 ud</h3>
            <a @click="dondecomprar = true" class="btn-comprar">Donde comprar</a>
          </article> -->
          <article class="producto">
            <div class="imagen"><img src="/static/img/momento-ganador/caja-cereza.png" alt="Kojak Original - Bolsa 100 ud">
            </div>
            <h3>Kojak Pop<br>Sabor Fresa 100ud</h3>
            <a href="https://tienda.fiesta.es/es/caramelos-con-palo/236-kojak-pop-fresa-promo-8411402290296.html" target="_blank" class="btn-comprar">Compra online</a>
          </article>

          <article class="producto">
            <div class="imagen"><img src="/static/img/momento-ganador/caja-kojak.png" alt="Kojak Original - Caja 100 ud">
            </div>
            <h3>Kojak Original<br>Sabor Cereza 100ud</h3>
            <a href="https://tienda.fiesta.es/es/caramelos-con-palo/167-kojak-cereza-promo-8411402232708.html" target="_blank" class="btn-comprar">Compra online</a>
          </article>

          <img src="/static/img/momento-ganador/estrellas.svg" alt="estrellas" class="estrellas-1">
          <img src="/static/img/momento-ganador/estrellas-dos.svg" alt="estrellas" class="estrellas-2">
          <img src="/static/img/momento-ganador/estrellas-tres.svg" alt="estrellas" class="estrellas-3">


        </div>

        <div class="contenedor-popup row-center" v-if="dondecomprar">
          <div class="popup">
            <a @click="dondecomprar = false" class="cerrar">✕</a>
            <p>Disponible en:</p>
            <div class="tiendas row-center">
              <a href=""><img src="/static/img/cod/logo-carrefour.png" alt=""></a>
              <a href=""><img src="/static/img/cod/alcampo-logo.png" alt=""></a>
              <a href=""><img src="/static/img/cod/logo-dia.png" alt=""></a>
              <a href=""><img src="/static/img/cod/eci-triangulo-logo.png" alt=""></a>
            </div>
          </div>
        </div>

      </section>


      <div class="contenedor-video">
        <!-- <img src="/static/img/momento-ganador/kojak.png" alt="kojak" class="kojak"> -->
        <video controls playsinline="true" poster="/static/img/momento-ganador/frame-video-tres.jpg">
          <source src="/static/img/momento-ganador/video-tres.mp4" type="video/mp4">
        </video>

      </div>


      <section class="kojakpop">
        <div class="container">
          <h2 class="title">Qué es Kojak Pop</h2>
          <h3 class="subtitle -white">Siente la experiencia</h3>
          <img src="/static/img/momento-ganador/logo-kojakpop.gif" alt="">
          <p>Prueba el nuevo Kojak relleno de tierno masticable sabor fresa</p>
          <p>¡Y con auténticas chipas!</p>
          <img src="/static/img/momento-ganador/kojak-pop.gif" class="kojak-pop">
        </div>
      </section>


      <section class="metele-fiesta">

        <div class="container">
          <h2 class="title">#Mételefiesta</h2>
          <div class="contenedor-imagenes row-center">
            <div class="imagen"><img src="/static/img/momento-ganador/metele-1.jpg" alt="Imagen 1"></div>
            <div class="imagen"><img src="/static/img/momento-ganador/metele-2.jpg" alt="Imagen 2"></div>
            <div class="imagen"><img src="/static/img/momento-ganador/metele-3.jpg" alt="Imagen 3"></div>
            <div class="imagen"><img src="/static/img/momento-ganador/metele-4.jpg" alt="Imagen 4"></div>
          </div>

          <h3>descubre + momentos top
            en nuestras redes sociales</h3>

          <nav class="row-center">
            <a class="facebook" href="https://www.facebook.com/Fiesta.ES/" target="_blank"><i class="fa fa-facebook"></i></a>
            <a class="twitter" href="https://twitter.com/FIESTA_es" target="_blank"><i class="fa fa-twitter"></i></a>
            <a class="instagram" href="https://www.instagram.com/fiesta.es/" target="_blank"><i class="fa fa-instagram"></i></a>
            <a class="linkedin" href="https://www.linkedin.com/company/fiesta/" target="_blank"><i class="fa fa-linkedin"></i></a>
            <a class="youtube" href="https://www.youtube.com/channel/UCtRixMwzH403OfMoR3XAPDw" target="_blank"><i class="fa fa-youtube"></i></a>
          </nav>

        </div>

      </section>

      <section class="banner-contacto row-center">

        <div class="banner column-center">

          <h2 class="title">¿Tienes alguna duda?</h2>

          <router-link to="/contacto" class="btn -white">Contactar</router-link>
        </div>

      </section>

      <section class="claim-legal">
        <div class="container">
          <p>España, solo mayores de 18 años.</p>
          <p>Registra tu código online desde el 15/05/2023 hasta el 15/09/2023.</p>
          <p>El sorteo del viaje a Corea del Sur se realizará según lo establecido en Bases Legales y la comunicación del ganador/a se realizará el 15 de octubre de 2023.</p>
          <p>Cuantas más participaciones, más posibilidades de ganar. No es válido repetir el mismo código único. Para más información consulte las <a target="_blank" href="https://terms.easypromosapp.com/t/48913">Bases Legales
              de la Promoción.</a>.</p>
          <p>Fiesta Colombina S.L., Avenida de Madrid, 46, 28802 Alcalá de Henares, Madrid, España.</p>

        </div>
      </section>

      <!-- 
    <section class="promocion-finalizada row-center">
      <h2 class="title">La promoción ha terminado</h2>
    </section> -->

    </template>

    <ruleta @finish="finishRuleta" v-if="showRuleta"></ruleta>

    <no-ganador @tryagain="tryagain" @reset="reset" v-if="showNoGanador"></no-ganador>

    <ganador @reset="reset" @tryagain="tryagain" v-if="showGanador"></ganador>

    <section class="cover-popup row-center" v-if="showPopupTirada">

      <div class="popup">
        <h2>Enhorabuena</h2>
        <p>Ya tienes disponible tu participación extra
        </p>
        <a @click="enableTirada" class="btn-enviar -blue -enviar-white">Tirar de nuevo</a>
      </div>

    </section>

  </div>

</template>

<script lang="js">

  import formulario from '@/components/view-parts/momento-ganador/formulario.vue'
  import ruleta from '@/components/view-parts/momento-ganador/ruleta.vue'
  import noganador from '@/components/view-parts/momento-ganador/no-ganador.vue'
  import ganador from '@/components/view-parts/momento-ganador/ganador.vue'

  import sliderPremios from '@/components/view-parts/momento-ganador/slider-premios.vue'

  import { mapActions, mapGetters } from 'vuex';

  export default {
    name: 'momento-ganador',
    mounted() {
      setTimeout(e => {
        this.showanimation = true;
      }, 1000);

      this.requestProvincias();
      this.requestDominios();

      document.title = 'Toma Relleno';
      document.head.querySelector("[name=description]").content = 'TOMA RELLENO – Gana un viaje a Corea, entradas para festivales, suscripciones a spotify, tarjetas regalo amazon y muchos premios más!';
      document.head.querySelector("[property='og:title']").content = 'Toma Relleno';
      document.head.querySelector("[property='og:url']").content = 'Toma Relleno';
      document.head.querySelector("[name='twitter:title']").content = 'Toma Relleno';
      document.head.querySelector("[property='og:description']").content = 'TOMA RELLENO – Gana un viaje a Corea, entradas para festivales, suscripciones a spotify, tarjetas regalo amazon y muchos premios más!';
      document.head.querySelector("[name='twitter:description']").content = 'TOMA RELLENO – Gana un viaje a Corea, entradas para festivales, suscripciones a spotify, tarjetas regalo amazon y muchos premios más!';
      document.head.querySelector("[property='og:image']").content = location.origin + '/static/img/momento-ganador/rrss_promo_fiesta.jpg';
      document.head.querySelector("[name='twitter:image']").content = location.origin + '/static/img/momento-ganador/rrss_promo_fiesta.jpg';
      document.head.querySelector("[property='og:url']").content = location.href;
      document.head.querySelector("[name='twitter:url']").content = location.href;

    },
    data() {
      return {
        showanimation: false,
        showRuleta: false,
        showFormulario: true,
        showNoGanador: false,
        showGanador: false,
        dondecomprar: false,
        showPopupTirada: false
      }
    },
    methods: {
      ...mapActions(['requestDominios', 'requestProvincias', 'resetData', 'setLoser', 'requestTiradaExtra']),
      initRuleta() {
        this.showFormulario = false;
        this.showRuleta = true;
        $('html, body').animate({
          scrollTop: 0
        }, 1000);
      },
      finishRuleta() {
        this.showRuleta = false;

        if (this.result.ganador) {
          this.showGanador = true;
        } else {
          this.showNoGanador = true;
        }

      },
      scrollTo(id) {
        $('html, body').animate({
          scrollTop: $("#" + id).offset().top - 100
        }, 1000);
      },
      reset() {
        this.resetData();
        this.showFormulario = true;
        this.showNoGanador = false;
        this.showGanador = false;
        this.showRuleta = false;
        setTimeout(e => {
          this.scrollTo('formulario');
        }, 1000)
      },
      tryagain() {
        this.requestTiradaExtra().then(r => {
          if (r) {
            this.showPopupTirada = true;
          }
        });
      },
      enableTirada() {
        setTimeout(e => {

          this.showPopupTirada = false;
          this.showRuleta = true;
          this.showGanador = false;
          this.showNoGanador = false;
          this.setLoser();
          $('html, body').animate({
            scrollTop: 0
          }, 1000);
        }, 500);
      },
      down() {
        scroll({
          top: document.getElementById("formulario").offsetTop - 200,
          behavior: "smooth"
        });
      }
    },
    computed: {
      ...mapGetters({
        result: 'getResultParticipacion',
      })
    },
    components: {
      'formulario': formulario,
      'ruleta': ruleta,
      'no-ganador': noganador,
      'ganador': ganador,
      'slider-premios': sliderPremios
    }
  }
</script>

<style lang="scss" scoped>
  .cover-popup {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .7);
    z-index: 10;
    padding: 20px;

    .popup {
      background: white;
      display: inline-block;
      padding: 20px;
      width: 100%;
      max-width: 500px;
      border-radius: 10px;
    }
  }

  @media screen and (max-width: 360px) {
    .cover-popup {
      .-enviar-white {
        padding-right: 20px;
      }

      .-enviar-white::before {
        display: none;
      }
    }
  }

  .close h3 {
    color: white;
    font-weight: bold;
    max-width: 768px;
    margin: 0 auto;
  }


</style>


// WEBPACK FOOTER //
// src/components/views/momento-ganador.vue